import { create, StateCreator } from 'zustand';

interface TimeFormatState {
  timeFormat: 'gregorian' | 'ethiopian';
  setTimeFormat: (format: 'gregorian' | 'ethiopian') => void;
}

export const useTimeFormatStore = create<TimeFormatState>((set: StateCreator<TimeFormatState>['set']) => ({
  timeFormat: 'ethiopian', // Changed default to ethiopian
  setTimeFormat: (format: 'gregorian' | 'ethiopian') => set({ timeFormat: format }),
})); 